<a (click)="navigate()" class="pointer" title="Parent Task">{{data.input.card.parentTicket.displayId}}</a> / {{data.input.card.name}}
